import { Component, EventEmitter, ElementRef, Input, Output, forwardRef, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';


@Component({
	selector: 'bb-radio',
	templateUrl: './bb-radio.component.html',
	styleUrls: ['./bb-radio.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbRadioComponent),
		multi: true
	}]

})

export class BbRadioComponent implements ControlValueAccessor, OnInit, OnChanges {

	@Input() formControl: UntypedFormControl;
	@Input() checked = false;
	@Input() disabled = false;
	@Input() label: string;
	@Input() name: string;
	@Input() val: string;
	@Input() shape: 'circular' | 'square';

	@Output() onChanged = new EventEmitter<string>();

	el: HTMLElement;
	propagateChange: any;

	constructor(private _eref: ElementRef) {
		this.el = this._eref.nativeElement;
	}

	ngOnInit() {
		if (typeof this.shape === 'undefined') {
			this.shape = 'circular';
		}
		this.checked = false;
		this.el.onclick = (e) => {

			const target = (e.target as HTMLElement);

			if (target.tagName === 'BB-RADIO' && target.parentNode && (target.parentNode as HTMLElement).tagName === 'LABEL') {
				// todo decent solution
				// ignore click on our bb-check node, if we are rendered inside of a label
				return;
			}
		};
	}

	ngOnChanges(changes: SimpleChanges) {

	}

	clicked() {
		if (this.disabled) {
			return;
		}

		this.checked = true;
		this.onChanged.emit(this.val);

		if (typeof this.propagateChange !== 'undefined') {
			if (this.formControl) {
				this.formControl.setValue(this.val);
			} else {
				this.propagateChange(this.val);
			}
		}
	}

	writeValue(value: string) {
		if (this.formControl) {
			this.checked = this.formControl.value === this.val;
		} else {
			this.checked = value === this.val;
		}
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}
}
